import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  getSingleAssets: [],
  setAssetsStatus: null,
  getUnlinkAssets: [],


  getModules: [],
  // setUnlink: null
};

const AssetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_SINGLE_ASSETS:
      state = { ...state, getSingleAssets: action.payload };
      break;
    case ActionTypes.RESET_SINGLE_ASSETS:
      state = { ...state, getSingleAssets: [] };
      break;
    case ActionTypes.SET_ASSETS_STATUS:
      state = { ...state, setAssetsStatus: action.payload };
      break;
    case ActionTypes.GET_UNLINK_ASSETS:
      state = { ...state, getUnlinkAssets: action.payload };
      break;
    case ActionTypes.RESET_UNLINK_ASSETS:
      state = { ...state, getUnlinkAssets: [] };
      break;
    case ActionTypes.GET_MODULES:
      state = { ...state, getModules: action.payload };
      break;
    case ActionTypes.RESET_MODULES:
      state = { ...state, getModules: [] };
      break;
    case ActionTypes.DLT_MODULE_FROM_ASSET:
      let singleAsset_list = [...state.getSingleAssets];
      let singleAsset_index = singleAsset_list.findIndex(x => x.id === action.payload.id);
      singleAsset_list.splice(singleAsset_index, 1);
      state = {...state, getSingleAssets: singleAsset_list};
      // let findItem = state?.getSingleAssets.find((item)=>item?.id == action.payload.id)
      // console.log("stateeeeeeee",state.getSingleAssets, 
      //   findItem
      // );
      // singleAssetList.splice(eclass_index, 1, action.payload);
      // state = {...state, e_classes_list: eclass_list};
      //  state = { ...state, getSingleAssets: findItem };
      // let findItem = 
      // state = { ...state, getModules: [] };
      break;
    default:
      break;
  }
  return state;
};

export default AssetsReducer;
